




































import Vue from "vue";
import CustomTable from "@/components/Table/table.vue";
import CustomCheckbox from "@/components/Input/Checkbox.vue";
import { DataTableHeader } from "vuetify";
import { store } from "@/store/store";
import { SurveyDataTable } from "@/types/types";
import Utils from "@/utils/utils";
import router from "@/router/router";

interface SurveyTableData {
  headers: Array<DataTableHeader>;
  items_displayed: Array<string>;
}

export default Vue.extend({
  name: "SurveysTable",
  components: { CustomTable, CustomCheckbox },
  props: {
    selected: {
      type: Array as () => Array<string>
    },
    onSelectChange: {
      type: Function
    },
    searchFilter: {
      type: Object
    },
    shouldDisplayUpdateModal: {
      type: Function,
      default: () => undefined
    }
  },
  data(): SurveyTableData {
    return {
      headers: [
        { text: "", value: "selected", sortable: false },
        { text: "Actif", value: "active", width: "15%", align: "center" },
        { text: "Id Budget", align: "start", value: "id_budget" },
        { text: "Nom", align: "start", value: "name_survey" },
        { text: "Type", value: "type" },
        { text: "Agence", value: "agence" },
        { text: "Début", value: "start_date" },
        { text: "Fin", value: "end_date" },
        { text: "actions", value: "actions", sortable: false, width: "10%", align: "center" }
      ],
      items_displayed: []
    };
  },
  methods: {
    format_data(): Array<SurveyDataTable> {
      const survey_by_id = store.getters.SURVEY_ALL_ID;
      return survey_by_id.map((survey_id: string) => {
        let survey = { ...store.getters.SURVEY_BY_ID[survey_id] };
        survey.active = this.defineActive(survey);
        const user = store.getters.USER_BY_ID[survey.user];
        survey.user = user ? user.mail : "no user found"; //store.getters.USER_BY_ID[survey.user].mail;
        survey.agence = store.getters.AGENCE_BY_ID[survey.agence].name;
        survey.start_date = Utils.transformDateToYMD(survey.start_date);
        survey.end_date = Utils.transformDateToYMD(survey.end_date);
        return survey;
      });
    },
    defineActive(survey: SurveyDataTable): string {
      const diff_start = Utils.getDifferenceBetweenDate(Date.now(), new Date(survey.start_date).getTime());
      const diff_end = Utils.getDifferenceBetweenDate(Date.now(), new Date(survey.end_date).getTime());
      if (diff_end > 0) {
        return "Terminé";
      } else if (diff_start >= 0 && diff_end <= 0) {
        return "En cours";
      } else {
        return "En attente";
      }
    },
    CheckIfSelected(_id: string): boolean {
      return this.selected.findIndex((selected_item) => selected_item === _id) !== -1;
    },
    selectedToggleAll(selected: boolean): void {
      this.onSelectChange(selected ? [...this.items_displayed] : []);
    },
    selectedChange(_id: string): void {
      let selected_copy = [...this.selected];
      const found_id = selected_copy.findIndex((select: string) => select === _id);
      found_id !== -1 ? selected_copy.splice(found_id, 1) : selected_copy.push(_id);
      this.onSelectChange(selected_copy);
    },
    currentItems(items: Array<any>) {
      this.items_displayed = items.map((item) => item._id) as Array<string>;
    },
    customFilter(value: string | undefined, search: string, item: { [key: string]: string | boolean }) {
      const search_ = JSON.parse(search);
      return ![
        this.activeFilter(search_.active, item.active as string),
        this.agenceFilter(search_.agence, item.agence as string),
        this.typeFilter(search_.type, item.type as string),
        this.idBudgetFilter(search_.id_budget, item.id_budget as string),
        this.surveyNameFilter(search_.survey_name, item.name_survey as string)
      ].includes(false);
    },
    activeFilter(active: string | null, item: string) {
      if (active === "" || active === null) return true;
      return item.toLowerCase().indexOf(active.toLowerCase().trim()) !== -1 ? true : false;
    },
    agenceFilter(agence: string | null, item: string): boolean {
      return agence === "" || agence === null ? true : agence === item ? true : false;
    },
    typeFilter(type: string | null, item: string) {
      if (type === "" || type === null) return true;
      return item.toLowerCase().indexOf(type.toLowerCase().trim()) !== -1 ? true : false;
    },
    idBudgetFilter(id_budget: string | null, item: string) {
      if (id_budget === "" || id_budget === null) return true;
      return item.toLowerCase().indexOf(id_budget.toLowerCase().trim()) !== -1 ? true : false;
    },
    surveyNameFilter(survey_name: string | null, item: string) {
      if (survey_name === "" || survey_name === null) return true;
      return item.toLowerCase().indexOf(survey_name.toLowerCase().trim()) !== -1 ? true : false;
    },
    redirectToSurveyPage(item: any): void {
      router.push({ path: `/survey?surveyId=${item._id}` });
    }
  }
});
